
import { Button, ButtonManageRef, FormControl, NoseurObject, Scheme, TextAreaInput, TextInput } from "@rivtn/noseur";
import { ConfirmDialog } from "../ConfirmDialog";
import { Schemes, Utils } from "../../../utils";
import { i18nManager } from "../../../i18n";
import React from "react";
import { Elements } from "../Elements";
import MediaInput from "../MediaInput";

export interface ArticleDialogLabel {
    title: string;
    update: string;
    delete: string;
    publish: string;
    updateTitle: string;
    delete_desc: string;
    delete_title: string;
    titlePlaceholder: string;
    contentPlaceholder: string;
}

export interface ArticleDialogArticle {
    title: string;
    content: string;
    external_id?: string;
    extra_data?: NoseurObject<any>;
}

export interface ArticleDialogProps {
    labels: ArticleDialogLabel;
    article?: ArticleDialogArticle;
    preComponents?: React.ReactElement;
    secondaryComponents?: React.ReactElement;
    onDelete?: (article: ArticleDialogArticle, done?: (error?: string) => void) => void;
    onPublishOrUpdate?: (isCreate: boolean, title: string, content: string, selectedFile?: File | null, done?: (error?: string) => void) => void;
}

export function ArticleDialog(props: ArticleDialogProps) {
    const isUpdate = !!props.article;
    let selectedFile: File | undefined | null;
    const iframeRef = { current: null } as any;
    const dialogErrorRef = { current: null } as any;
    const { labels, article = {} as any, preComponents, secondaryComponents } = props;

    const dialog = ConfirmDialog({
        closable: true,
        noControl: true,
        maximized: true,
        style: { maxWidth: "100%", margin: 0 },
        content: (<div className="article-dialog">
            <div className="finputs">
                <p className="t">{isUpdate ? labels.updateTitle : labels.title}</p>
                {preComponents}
                <FormControl isFieldset fill label={labels.titlePlaceholder}>
                    <TextInput defaultValue={article?.title} onInputComplete={(v) => {
                        article!.title = v;
                    }} />
                </FormControl>
                <MediaInput instruction={i18nManager.Labels.common.click_to_choose} style={{ alignSelf: "center" }} width="100%" height={240} default={props?.article?.extra_data?.featured_image}
                    onSelectFiles={(files) => {
                        selectedFile = files[0];
                    }} onGenerateWithAi={async () => {
                        return new File(["We are here"], "we.txt", { type: 'text/plain' });
                    }} onRemove={async () => {
                        selectedFile = null;
                    }} />
                <FormControl isFieldset fill style={{ flex: 1, }} className="move-to-noseru-for-fieldset-content-customization" label={labels.contentPlaceholder}>
                    <TextAreaInput fill style={{ height: "100%" }} defaultValue={article?.content} onInput={({ target: { value } }: any) => {
                        article!.content = value;
                        if (!iframeRef.current) return;
                        iframeRef.current.src = 'data:text/html;charset=utf-8,' + encodeURIComponent(Utils.markdownToHtml(value));
                    }} />
                </FormControl>
                <div ref={dialogErrorRef} className="error" style={{ marginBottom: 10 }}> </div>
                <div className="controls">
                    <div>
                        <Button textOnly scheme={Schemes.OMNEHOST} text={<span style={{ fontWeight: "bold", color: "var(--mainColor)" }}>{i18nManager.Labels.common.close}</span>} onClick={() => {
                            dialog.hide();
                        }} />
                        {secondaryComponents}
                    </div>
                    <div>
                        {isUpdate && (<Button raised style={{ padding: "10px 35px" }} scheme={Scheme.DANGER} text={labels.delete} onClick={deleteArticle} />)}
                        <Button raised style={{ padding: "10px 35px", marginLeft: 20 }} scheme={Schemes.OMNEHOST} text={isUpdate ? labels.update : labels.publish}
                            loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                                e.manageRef?.setLoadingState(true);
                                props.onPublishOrUpdate?.(!isUpdate, article.title, article.content, selectedFile, (error?: string) => {
                                    e.manageRef?.setLoadingState(false);
                                    if (error) dialogErrorRef.current = error;
                                });
                            }} />
                    </div>
                </div>
            </div>
            {(document?.documentElement?.clientWidth > 800) && (<iframe ref={iframeRef} src={'data:text/html;charset=utf-8,' + encodeURIComponent(Utils.markdownToHtml(article?.content ?? ''))} />)}
        </div>),
    });

    function deleteArticle() {
        const delDialog = ConfirmDialog({
            closable: true,
            title: labels.delete_title,
            confirmScheme: Scheme.DANGER,
            desc: labels.delete_desc.replace("${title}", article!.title),
            onConfirm: (button?: ButtonManageRef) => {
                button?.setLoadingState(true);
                dialogErrorRef.current!.innerText = " ";
                props.onDelete?.(article, (error?: string) => {
                    button?.setLoadingState(false);
                    if (error) dialogErrorRef.current = error;
                    delDialog.hide(dialog.hide);
                })
                return false;
            }
        });
        delDialog.show();
    }

    return dialog;
};
